<template>
  <div class="pt-10">
    <base-search class="full-card" :is-search-header="true" />
    <div class="grid pa-5">
      <card-component
        @click="goToProductsSearch"
        class="full-card new-order"
        :title="$t('Header.neworder')"
        :subtitle="$t('Header.catitems')"
        :value="cartTotal"
        icon="mdi-cart-outline"
      />
      <card-component
        @click="$router.push('/invocies')"
        class="returns"
        :title="$t('Header.Returns')"
        :subtitle="$t('Header.catitems')"
        :value="openOrders"
        icon="mdi-invoice-text-outline"
      />
      <card-component
        @click="$router.push('/orders')"
        class="my-orders"
        :title="$t('Header.myorders')"
        :subtitle="$t('Header.catitems')"
        :value="openOrders"
        icon="mdi-text-box-search-outline"
      />
      <!-- <card-component
      @click="$router.push('/invocies')"
      class="returns"
      :title="$t('Header.tabFinances')"
      :subtitle="$t('Header.activefinances')"
      :value="openOrders"
      icon="mdi-invoice-text-outline"
    /> -->
      <card-component
        @click="$router.push('/finances')"
        class="cash"
        :title="$t('Header.finances')"
        :subtitle="$t('Header.activefinances')"
        :value="openOrders"
        icon="mdi-briefcase-outline"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseSearch from "../menus/BaseSearch.vue";
import CardComponent from "../helpers/CardComponent.vue";

export default {
  components: {
    BaseSearch,
    CardComponent,
  },
  methods: {
    goToProductsSearch() {
      this.$store.commit("setIsShowDesktopHome", true);
    },
  },
  computed: {
    ...mapGetters({
      cartTotal: "Orders/getCartTotal",
      openOrders: "Orders/getOpenOrders",
    }),
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
  gap: 20px;
  max-width: 500px;
  margin: auto;
}

@media only screen and (max-width: 375px) {
  .grid {
    grid-template-columns: 2fr;
  }
}

.full-card {
  grid-column-start: 1;
}
.new-order {
  background: $cartMainColor;
}
.returns {
  background: $invoicesAndReturns;
}
.my-orders {
  background: $ordersMainColor;
}
.cash {
  background: $cashMainColor;
}
</style>
